const CACHE_KEY = "home:pmxCatalogUpdates";
const CACHE_TTL_MS = 60_000;

/**
 * Reads cached PMX catalog updates if younger than TTL.
 * @returns {Array|null} Cached catalog rows or null if missing/expired
 */
export function getPmxCatalogUpdatesCache() {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY);
    if (!raw) return null;

    const { data, fetchedAt } = JSON.parse(raw);
    if (!Array.isArray(data) || typeof fetchedAt !== "number") {
      return null;
    }

    if (Date.now() - fetchedAt > CACHE_TTL_MS) {
      return null;
    }

    return data;
  } catch (error) {
    console.warn("Failed to read PMX catalog updates cache:", error.message);
    return null;
  }
}

/**
 * Persists PMX catalog updates for stale-while-revalidate on Home.
 * @param {Array} data - API response rows
 */
export function setPmxCatalogUpdatesCache(data) {
  try {
    sessionStorage.setItem(
      CACHE_KEY,
      JSON.stringify({ data, fetchedAt: Date.now() }),
    );
  } catch (error) {
    console.warn("Failed to write PMX catalog updates cache:", error.message);
  }
}
